import { Countries } from '../components/travellingCountries/countries';
import { BillingType } from './BillingTypes';
import { UserEquipmentsType } from './EquipmentTypes';
import { PortType } from './PortType';
import { ServiceRequestType } from './ServiceRequestTypes';
import { ShipType } from './ShipTypes';

export interface CertificationsType {
  _id: string;
  title: string;
  type: 'ISO' | 'MAKER' | 'CLASS' | 'FLAG';
  expiration: string;
  file: string;
  status: 'APPROVED' | 'PENDING' | 'EXPIRED' | 'REJECTED';
}

export enum NotificationTypeType {
  OFFER_UPDATED = 'OFFER_UPDATED',
  SERVICE_UPDATED = 'SERVICE_UPDATED',
}

export interface NotificationType {
  troubleshootingRequestId?: string;
  _id: string;
  type: NotificationTypeType;
  offerId: string;
  serviceRequestId: string;
  description: string;
}

export enum UserTypeType {
  SHIPPING_COMPANY = 'SHIPPING_COMPANY',
  SUPPLIER = 'SUPPLIER',
  ADMIN = 'ADMIN',
  BROKER = 'BROKER',
}

export interface PhotosType {
  label: string;
  url: string;
}
export interface FeesType {
  _id?: string;
  nobundle?: number;
  bundle5?: number;
  bundle10?: number;
  bundle15?: number;
  bundle20?: number;
  bundle30?: number;
  bundle50?: number;
  bundle100?: number;
  bundle200?: number;
  yearly?: number;
}

export const bundleTypes = [
  'nobundle',
  'bundle5',
  'bundle10',
  'bundle15',
  'bundle20',
  'bundle30',
  'bundle50',
  'bundle100',
  'bundle200',
  'yearly',
];

export enum SubscriptionStatusType {
  NONE = 'NONE',
  ACTIVE = 'ACTIVE',
  CANCEL_REQUESTED = 'CANCEL_REQUESTED',
  CANCELED = 'CANCELED',
}

export enum DepartmentEnum {
  TECHNICAL = 'TECHNICAL',
  TECHNICAL1 = 'TECHNICAL1',
  TECHNICAL2 = 'TECHNICAL2',
  TECHNICAL3 = 'TECHNICAL3',
  TECHNICAL4 = 'TECHNICAL4',
  TECHNICAL5 = 'TECHNICAL5',
  TECHNICAL6 = 'TECHNICAL6',
  TECHNICAL7 = 'TECHNICAL7',
  TECHNICAL8 = 'TECHNICAL8',
  TECHNICAL9 = 'TECHNICAL9',
  FLEEt1 = 'FLEET1',
  FLEEt2 = 'FLEET2',
  FLEEt3 = 'FLEET3',
  FLEEt4 = 'FLEET4',
  FLEEt5 = 'FLEET5',
  FLEEt6 = 'FLEET6',
  FLEEt7 = 'FLEET7',
  FLEEt8 = 'FLEET8',
  FLEEt9 = 'FLEET9',
  RADIO = 'RADIO',
  SAFETY = 'SAFETY',
  PURCHASING = 'PURCHASING',
  VETTING = 'VETTING',
  IT = 'IT',
  OPERATIONS = 'OPERATIONS',
  MARINE = 'MARINE',
  ELECTRONICS = 'ELECTRONICS',
}

export interface DepartmentsEmailsType {
  department: DepartmentEnum;
  email: string;
}

export interface PreferencesType {
  chatEmail: boolean;
  sendAllChatNotificationEmail: boolean;
  newOfferEmail: boolean;
  offerDeclinedEmail: boolean;
  onServiceArrangedShipEmail: boolean;
  allInfoOnServiceFinalizedEmail: boolean;
  onServiceCreatedEmail: boolean;
  onServiceCanceledEmail: boolean;
  newOfferDetailedEmail: boolean;
  noDepartmentEmailsToPrimary: DepartmentEnum[];
  brokerReceivesShippingCompanyEmails: boolean;
}

export interface UserType {
  _id: string;
  email: string;
  email2: string;
  email3: string;
  email4: string;
  safetyEmail: string;
  technicalEmail: string;
  type: UserTypeType;
  session: string;
  status: 'NEW' | 'UNDER_REVIEW' | 'APPROVED' | 'REJECTED';
  createdAt: string;
  companyName: string;
  nationality: string;
  headquarters: string;
  shipsNumber: string;
  logo: string;
  staff: number;
  website: string;
  phone: string;
  description: string;
  terms: string;
  photos: PhotosType[];
  certifications: CertificationsType[];
  ports: PortType[];
  ships: ShipType[];
  travelling: boolean;
  travellingCountries: Countries[];
  equipments: UserEquipmentsType[];
  serviceRequests: ServiceRequestType[];
  billing: BillingType;
  offers: string[];
  notifications?: NotificationType[];
  fees?: FeesType;
  remainingServices: number;
  subscriptionActivatedAt: string;
  subscriptionStatus: SubscriptionStatusType;
  subscriptionRenewal: string;
  rating: number;
  ratingCount: number;
  preferences: PreferencesType;
  favoriteSuppliers: string[];
  unfavoredSuppliers: string[];
  commission?: number;
  isTroubleshootingEnabled?: boolean;
  myTroubleshooterId?: string;
  bundlesEnabled?: boolean;
  termsAcceptanceDate: string;
  hasPendingInvoices: boolean;
  departments: DepartmentEnum[];
  departmentsEmails: DepartmentsEmailsType[];
}
